import {
  ActionFunctionParams,
  basicBlockActions,
  MenuOption,
} from 'articleEditor/utils/actions';
import {
  insertNodes,
  removeNodes,
} from 'lib-knowledge-document-structure/plate/common';
import {
  ELEMENT_OL,
  ELEMENT_UL,
  MyBulletedListElement,
  MyNumberedListElement,
  MyNumberedListElementActual,
} from 'lib-knowledge-document-structure/plateTypes';
import { RenderElementProps } from 'lib-knowledge-document-structure/slate/react';
import { useMemo } from 'react';

import { SortableBlockWrapper } from '../baseBlock';
import s from '../baseBlock/block.module.scss';

type OrderedListBlockProps = RenderElementProps & {
  element: MyNumberedListElement;
};

export default function OrderedListBlock({
  element,
  attributes,
  children,
}: OrderedListBlockProps): JSX.Element {
  const blockActions = useMemo(
    () => [...basicBlockActions, ...transformBlockActions],
    [],
  );

  return (
    <SortableBlockWrapper
      className={s['blockOrderedList']}
      element={element}
      blockActions={blockActions}
    >
      <OrderedListComponent element={element} attributes={attributes}>
        {children}
      </OrderedListComponent>
    </SortableBlockWrapper>
  );
}

type OrderedListComponentProps = RenderElementProps & {
  element: MyNumberedListElement;
};

function OrderedListComponent({
  attributes,
  children,
}: OrderedListComponentProps) {
  return (
    <ol {...attributes} className={s['blockContent']}>
      {children}
    </ol>
  );
}

const transformBlockActions: ReadonlyArray<MenuOption> = [
  { key: 'heading', label: 'Convert to' },
  {
    key: 'ul',
    label: 'Bulleted List',
    icon: 'list-ul',
    isSelected: false,
    action: transformOlToUl,
  },
  {
    key: 'ol',
    label: 'Numbered List',
    icon: 'list-ol',
    isSelected: true,

    action: () => {},
  },
];

function transformOlToUl({ element, editor, path }: ActionFunctionParams) {
  const newElement = convertOlToUl(element as MyNumberedListElementActual);
  removeNodes(editor, { at: path });
  insertNodes(editor, newElement, { at: path });
}

function convertOlToUl(
  element: MyNumberedListElement | MyNumberedListElementActual,
): MyBulletedListElement {
  const actualElement = element as MyNumberedListElementActual;
  return {
    id: actualElement.id,
    type: ELEMENT_UL,
    // eslint-disable-next-line
    // @ts-ignore
    children: actualElement.children.map((liChild) => {
      // c.type is 'li'
      return {
        ...liChild,
        children: liChild.children.map((subChild) => {
          if (subChild.type === ELEMENT_OL) {
            // eslint-disable-next-line
            // @ts-ignore
            return convertOlToUl(subChild);
          }
          return subChild;
        }),
      };
    }),
  };
}
